var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SearchableDocumentsList", {
    attrs: {
      query: _vm.query,
      classCarePlan: "!h-auto",
      companyId: _vm.companyId,
      projectId: _vm.clientId,
      frozen: _vm.projectCompleted,
      clientId: _vm.clientId,
      allowUploads: !!_vm.clientId && _vm.clientId.length > 0,
      showMissingClientMessage: !_vm.clientId || _vm.clientId.length === 0,
      showFileList: !!_vm.clientId && _vm.clientId.length > 0,
      currentUserRole: _vm.userRole,
      currentUser: _vm.currentUser,
      isProject: _vm.isProject,
      extraInfoHidden: "",
    },
    on: {
      listChanged: function ($event) {
        return _vm.$emit("documentsListChanged")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "secondaryData",
        fn: function ({ document }) {
          return [
            _c(
              "CardInfoChip",
              _vm._b(
                {
                  attrs: {
                    message: _vm.getAccessScope(document),
                    showDecoration: false,
                  },
                },
                "CardInfoChip",
                _vm._d({}, [_vm.getBadgeColor(document), true])
              )
            ),
          ]
        },
      },
      {
        key: "optionalActions",
        fn: function ({
          documentId,
          fileName,
          documentExtension,
          uploadedByUserId,
          refetchDocuments,
        }) {
          return [
            _vm.accessScopeEditable(uploadedByUserId)
              ? _c("ProjectDocumentAccessScope", {
                  staticClass: "flex justify-center w-full",
                  attrs: {
                    documentId: documentId,
                    fileName: fileName,
                    documentExtension: documentExtension,
                    projectId: _vm.clientId,
                    currentUserRole: _vm.userRole,
                  },
                  on: { accessScopeUpdated: refetchDocuments },
                })
              : _vm._e(),
          ]
        },
      },
      {
        key: "emptyListAction",
        fn: function () {
          return [
            _c(
              "p",
              {
                staticClass: "text-md my-16 text-primary-black text-center",
                staticStyle: { width: "100%" },
              },
              [_vm._v("There are currently no documents.")]
            ),
            _c("UploadDocument", {
              staticClass: "flex justify-center mt-4",
              attrs: {
                companyId: _vm.companyId,
                projectId: _vm.clientId,
                currentUserId: _vm.currentUser.id,
                currentUserParent: _vm.currentUser,
                useButton: false,
              },
              on: {
                documentAdded: function ($event) {
                  return _vm.$emit("refreshDocuments")
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function ({ refetchDocuments }) {
          return [
            _c("UploadDocument", {
              staticClass: "flex justify-end relative",
              attrs: {
                companyId: _vm.companyId,
                projectId: _vm.clientId,
                variant: "transparent",
                currentUserId: _vm.currentUser.id,
                currentUserParent: _vm.currentUser,
                useButton: true,
              },
              on: { documentAdded: refetchDocuments },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }